import { Text } from "@portal/components/primitives";
import { Separator } from "@portal/components/ui/Separator";
import type { FC, ReactNode } from "react";

export type AgentBondRequestHeaderNoticeProps = {
	icon: ReactNode;
	children: ReactNode;
	textClassName?: string;
};

export const AgentBondRequestHeaderNotice: FC<AgentBondRequestHeaderNoticeProps> = ({
	icon,
	children,
	textClassName,
}) => (
	<div
		data-testid="agent-bond-request-header-notice"
		className="min-h-fit flex items-center justify-center space-x-[12px] px-2 py-[12px]"
	>
		<div className="shrink-0">{icon}</div>
		<Separator orientation="vertical" className="h-[20px] w-[1.5px] bg-bc-default shrink-0" />
		<Text type="body-strong" color="secondary" className={textClassName}>
			{children}
		</Text>
	</div>
);
